import { useEffect, useRef } from "react";
import { useAnimate } from "framer-motion";
import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";
import "./../../../index.css";
const hiddenText: React.CSSProperties = {
  opacity: 0,
  transform: "translateY(32px)",
  willChange: "transform, opacity",
};

const hiddenImg: React.CSSProperties = {
  opacity: 0,
  transform: "translateY(40px)",
  willChange: "transform, opacity",
};

export const Section3 = () => {
  const isMobile = useResponsiveMobile(900);
  const hostRef = useRef<HTMLDivElement | null>(null);
  const [scope, animate] = useAnimate();
  const ranRef = useRef(false);
  const logos = [
    "/assets/images/logo/wisecare.png",
    "/assets/images/logo/wayup.png",
    "/assets/images/logo/paytus.png",
    "/assets/images/logo/kis.png",
    "/assets/images/logo/kurly.png",
    "/assets/images/logo/paystory.png",
    "/assets/images/logo/korpay.png",
    "/assets/images/logo/passgo.png",
    "/assets/images/logo/ud.png",

    "/assets/images/logo/lotte.png",
    "/assets/images/logo/kb.png",

    "/assets/images/logo/nice.png",
    "/assets/images/logo/flserv.png",
    "/assets/images/logo/tmoney.png",
    "/assets/images/logo/todayhouse.png",
    "/assets/images/logo/smartro.png",
    "/assets/images/logo/monki.png",
    "/assets/images/logo/paystore.png",
    "/assets/images/logo/wholebig.png",
    "/assets/images/logo/moin.png",
    "/assets/images/logo/manna.png",
    "/assets/images/logo/paytus.png",
    "/assets/images/logo/yumyum.png",
    "/assets/images/logo/skyclass.png",
    "/assets/images/logo/chungho.png",
    "/assets/images/logo/korbill.png",
    "/assets/images/logo/cellfieglobal.png",
    "/assets/images/logo/twc.png",
    "/assets/images/logo/beaverworks.png",
    "/assets/images/logo/damapay.png",
    "/assets/images/logo/obesis.png",
    "/assets/images/logo/law.png",
    "/assets/images/logo/koreaculture.png",
    "/assets/images/logo/rom.png",
    "/assets/images/logo/seed.png",
    "/assets/images/logo/raemi.png",
    "/assets/images/logo/cellfie.png",
    "/assets/images/logo/hello.png",
    "/assets/images/logo/c1.png",
    "/assets/images/logo/urgent.png",
    "/assets/images/logo/finger.png",
    "/assets/images/logo/buddy.png",
    "/assets/images/logo/payment.png",
    "/assets/images/logo/npi.png",
    "/assets/images/logo/kingorder.png",
    "/assets/images/logo/iaurora.png",
    "/assets/images/logo/connectree.png",
    "/assets/images/logo/pmgrow.png",
    "/assets/images/logo/wonik.png",
    "/assets/images/logo/pne.png",
    "/assets/images/logo/costel.png",
    "/assets/images/logo/adt.png",
    "/assets/images/logo/nobletree.png",
    "/assets/images/logo/bithumb.png",
  ];
  const splitLogosForMobile = (logos: string[]) => {
    const rows = [[], [], []] as string[][];
    logos.forEach((logo, idx) => {
      rows[idx % 3].push(logo);
    });
    return rows;
  };

  const mobileRows = splitLogosForMobile(logos);
  useEffect(() => {
    ranRef.current = false;
    let alive = true;
    const el = hostRef.current;
    if (!el) return;

    const run = async () => {
      if (ranRef.current) return;
      ranRef.current = true;
      if (!alive) return;

      //  텍스트 + 이미지 “동시에” 등장
      const animations = [
        animate(
          ".s3-text",
          { opacity: 1, y: 0 },
          {
            duration: 1.8,
            ease: [0.12, 0.9, 0.2, 1],
          },
        ),
      ];
      if (!isMobile) {
        animations.push(
          animate(
            ".s3-eg3",
            { opacity: 1, y: 0 },
            {
              duration: 1.8, //  같은 duration으로 맞추면 완전 동시 체감
              ease: [0.12, 0.9, 0.2, 1],
            },
          ),
        );
      }
      await Promise.all(animations);
    };

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) run();
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -35% 0px",
      },
    );

    io.observe(el);
    return () => {
      alive = false;
      io.disconnect();
    };
  }, [animate, isMobile]);

  return (
    <div
      ref={(node) => {
        hostRef.current = node;
        (scope as any).current = node;
      }}
      className="flex flex-col gap-20 w-full justify-center items-center pt-[40px] md:pt-0"
    >
      {/*  텍스트 */}
      <div className="s3-text flex flex-col gap-8 md:gap-6 px-6 md:px-0" style={hiddenText}>
        <div className="flex flex-col gap-3">
          <span className="font-normal text-[18px] md:text-[20px] text-[#0079FF] text-center">
            제작사 소개
          </span>
          <span className="font-bold text-[36px] md:text-display text-center">
            전문성과 신뢰 {isMobile && <br />} <span className="text-[#0079FF]">품의 기술력</span>
          </span>
        </div>

        <span className="font-normal text-[#4D4F58] text-center md:text-heading1">
          {isMobile ? (
            <div className="flex flex-col gap-8">
              <span className="text-center text-[18px]">
                우리는 40개 이상의 전문 PG 및<br />
                선불 시스템을 구축해온 경험이 있습니다.
              </span>

              <span className="text-[16px] leading-[1.5]">
                다양한 업종과 거래 구조를 설계하며
                <br />
                쌓은 현업 운영 노하우를 바탕으로
                <br />
                비즈니스 환경에 딱 맞춘 고도화된
                <br />
                결제·정산 통합 프로그램을 제공합니다.
              </span>
            </div>
          ) : (
            <>
              우리는 40개 이상의 전문 PG 및 선불 시스템을 구축해온 경험이 있습니다. <br />
              다양한 업종과 거래 구조를 설계하며 쌓은 현업 운영 노하우를 바탕으로 <br />
              비즈니스 환경에 딱 맞춘 고도화된 결제·정산 통합 프로그램을 제공합니다.
            </>
          )}
        </span>
      </div>

      {/*  eg3: 텍스트와 같이 등장 */}

      {isMobile ? (
        <div className="relative w-full overflow-hidden">
          {mobileRows.map((row, rowIdx) => (
            <div key={rowIdx} className="relative w-full overflow-hidden">
              <div className="logo-track">
                {[...row, ...row].map((src, idx) => (
                  <img
                    key={idx}
                    src={src}
                    className="w-20 h-[35px] object-contain opacity-80"
                    draggable={false}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <img
          className="s3-eg3 px-[24px]"
          style={hiddenImg}
          src="/assets/images/case/eg3.png"
          alt="eg3"
        />
      )}
    </div>
  );
};
